/** Source zone for Benzinga wire-format timestamps (yyyyMMddHHmmss). */
export const MARKET_DATA_SOURCE_ZONE = 'America/New_York';

/** Wire / compact parse formats */
export const COMPACT_DATE_TIME_FORMAT = 'yyyyMMddHHmmss';
export const COMPACT_DATE_FORMAT = 'yyyyMMdd';

/** Grid display output formats */
export const DISPLAY_DATE_FORMAT = 'yyyy-MM-dd';
export const DISPLAY_DATE_TIME_24H_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const DISPLAY_DATE_TIME_AM_PM_FORMAT = 'yyyy-MM-dd hh:mm:ss a';
export const TIME_24H_FORMAT = 'HH:mm:ss';
export const TIME_AM_PM_FORMAT = 'hh:mm:ss a';

/** Pre-formatted / localized parse formats */
export const LOCALIZED_DATE_LONG_FORMAT = 'MMM d, yyyy';
export const LOCALIZED_DATE_TIME_AM_PM_FORMAT = 'MMM d, yyyy h:mm a';
export const LOCALIZED_DATE_TIME_24H_FORMAT = 'MMM d, yyyy HH:mm';
export const US_DATE_FORMAT = 'MM/dd/yyyy';

export const LOCALIZED_DATE_FORMATS = [LOCALIZED_DATE_LONG_FORMAT, US_DATE_FORMAT] as const;

export const LOCALIZED_DATE_TIME_FORMATS = [LOCALIZED_DATE_TIME_AM_PM_FORMAT, LOCALIZED_DATE_TIME_24H_FORMAT] as const;

export const PRE_FORMATTED_DATE_TIME_FORMATS = [...LOCALIZED_DATE_TIME_FORMATS, DISPLAY_DATE_TIME_24H_FORMAT] as const;

export const DISPLAY_DATE_FORMATS = [DISPLAY_DATE_FORMAT, ...LOCALIZED_DATE_FORMATS] as const;

export const DISPLAY_DATE_TIME_FORMATS = [
  DISPLAY_DATE_TIME_AM_PM_FORMAT,
  DISPLAY_DATE_TIME_24H_FORMAT,
  DISPLAY_DATE_FORMAT,
  ...LOCALIZED_DATE_TIME_FORMATS,
] as const;
